import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { V2ThemeProvider } from '@onevision-resources/design-theme';
import { useCallback, useMemo, useState } from 'react';
import { Modals, useModalMethods } from 'src/store/modals';
import { PlatformUserRaw } from 'src/types';

export const UsersActionsMenu = ({
  onCreateUser,
  partnerId,
}: {
  onCreateUser: (data: Partial<PlatformUserRaw>) => void;
  partnerId: number | null;
}) => {
  const { showModal } = useModalMethods(Modals.CreateUser);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = useMemo(() => !!anchorEl, [anchorEl]);

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCreateUser = useCallback(() => {
    handleClose();
    showModal({
      onSubmit: onCreateUser,
      partnerId,
    });
  }, [showModal, onCreateUser, partnerId]);

  return (
    <Box>
      <Button
        id="user-actions-menu"
        data-testid="users-actions-menu"
        aria-controls={open ? 'user-actions-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleMenuOpen}
      >
        Menu
      </Button>
      <V2ThemeProvider>
        <Menu
          id="user-actions-menu"
          aria-labelledby="user-actions-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
        >
          <MenuItem data-testid="users-actions-menu-create-user" onClick={handleCreateUser}>
            Create User
          </MenuItem>
        </Menu>
      </V2ThemeProvider>
    </Box>
  );
};
